/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "payments": {
        "nested": {
          "api": {
            "nested": {
              "DelayCaptureReason": {
                "values": {
                  "INVALID_DEFAULT_DELAY_CAPTURE_REASON": 0,
                  "TIP_ON_PAPER_RECEIPT": 1,
                  "FULFILLMENT": 2,
                  "REOPENABLE": 3
                }
              },
              "SetMetadataResponse": {
                "nested": {
                  "Status": {
                    "values": {
                      "ERROR": 0,
                      "SUCCESS": 1,
                      "PAYMENT_NOT_FOUND": 2,
                      "INVALID_DELAY_CAPTURE_REASON": 3,
                      "INVALID_CAPTURE_STATE": 4
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.payments?.nested?.api?.nested?.DelayCaptureReason && !$root.nested?.squareup?.nested?.payments?.nested?.api?.nested?.SetMetadataResponse?.nested?.Status) {
  $root.addJSON(jsonData);
}

/**
 * Enum of reasons why a payment can have a delayed capture.
 *
 * SOURCE DelayCaptureReason @ squareup/payments/set_metadata.proto at 9:1
 */
export const DelayCaptureReason = $root.lookupEnum('squareup.payments.api.DelayCaptureReason').values;
/**
 * Response to request to mark a particular payment as delayed capture.
 *
 * SOURCE SetMetadataResponse @ squareup/payments/set_metadata.proto at 34:1
 */
export const SetMetadataResponse = {};
/**
 * SOURCE Status @ squareup/payments/set_metadata.proto at 35:3
 */
SetMetadataResponse.Status = $root.lookupEnum('squareup.payments.api.SetMetadataResponse.Status').values;